module.exports = __webpack_public_path__ + "static/media/chainsaw.52f2bdb8.PNG";